import { React, Styled } from '@common/3rd';
import { PageComponents, SignCommonPageComponents2, StyledProps, ButtonType, CheckRuleOptions } from '@my-types';
import { Apis, PATH, Storage, Utils } from '@common';
import { DeskPage } from '@desk-component';
import { DeskPanel, DeskPanelBody, DeskButton } from '@desk-component';
import { StyledComponents } from '@styles';
import { fileList } from '../const';
import { Checker } from '@model';
import Alert from '@alert';
import Dialog from '@dialog';
import { useState, useRef, useEffect } from 'react';
import { smsCount, captchaCodeLength } from '../const';
const Line = Styled.div`
    width: 100%;
    line-height: 1.5;
    color: #999;
    &:not(.sms-btn) {
        padding-left: 10px;
        padding-top: 5px;
    }
`;
class SignCommonPage extends DeskPage<any, any, PageComponents & SignCommonPageComponents2> {
    fieldCheck: {[propName: string]: any};
    constructor(props: any, context: any) {
        super(props, context);
        this.fieldCheck = {
            mobile: { name: '手机号', rule: [Checker.LUXURIANT.REQUIRED_WITH_NAME, Checker.LUXURIANT.MOBILE] },
            validateCode: { name: '验证码', rule: [Checker.LUXURIANT.REQUIRED_WITH_NAME, {
                do: (options: CheckRuleOptions): boolean | string => {
                    const { value } = options;
                    if (value && !/^\d{6}$/.test(value)) {
                        return '请输入正确的验证码'; //'长度为6个字符'; 2022.06.29 验证码规则：6位数字;
                    }
                    return true;
                }
            }] },
            password: { name: '密码', rule: [Checker.LUXURIANT.REQUIRED_WITH_NAME] },
            confirmPassword: { name: '确认密码', rule: [Checker.LUXURIANT.REQUIRED_WITH_NAME] }
        }
    }
    async componentDidMount() {
        await super.componentDidMount();
        if (this.tenantCode) {
            this.getPwdStrategy(this.tenantCode, this.fieldCheck);
        }
    }
    componentWillUnmount(){
        this.stopInterval();
    }
    protected sendSmsCode = async () => {
        // validate mobile
        await this.onBlur(this.fieldCheck, 'mobile');
        if (this.state.errorMsg?.mobile && this.state.errorMsg.mobile.length) {
            return;
        }
        if (this.state.canSend) {
            let operationType = ''; // 验证码类型:100 注册,101登录,102 重置密码
            if (window.location.href.includes(PATH.DESK2_SIGN_IN)) {
                operationType = '101';
            } else if (window.location.href.includes(PATH.DESK2_SIGN_UP)) {
                operationType = '100';
            } else {
                operationType = '102';
            }
            try {
                let params: {[propName: string]: any} = {
                    tenantCode: this.tenantCode,
                    operationType:  operationType,
                    mobile: this.state.mobile
                };
                if (this.state.validCaptchaCode) {
                    if (this.state.captchaCode) {
                        params.imageVerificationCode = this.state.captchaCode;
                    } else {
                        this.triggerCaptcha((captchaCode: string) => {
                            this.setState({ captchaCode: captchaCode });
                            this.sendSmsCode();
                        });
                        return;
                    }
                }
                let res = await this.getHelpers().getAjax().post(Apis.MEJ_VALIDATE,  Object.assign({},params,{
                    decryptedBody: Utils.generateSmsDecryptedBody(params.mobile)
                }), { loading: true });
                this.setState({ captchaCode: '' });
                this.startInterval(smsCount);
                if (res?.body?.body?.code === 'needImageVerification') { // 发送验证码超过5次不触发倒计时
                    this.stopInterval();
                    this.setState({
                        count: smsCount,
                        canSend: true,
                        validCaptchaCode: true
                    });
                    this.triggerCaptcha((captchaCode: string) => {
                        this.setState({ captchaCode: captchaCode });
                        this.sendSmsCode();
                    });
                }
            } catch (e) {
                console.log('send validate code error', e);
                Alert.hide();
                if (e?.body?.errors && e.body.errors.length) {
                    if(e.body.errors[0].code === 'ACCOUNT_VALIDATE_NEED_SET_PASSWORD'){
                        Alert.error(e.body.errors[0].description).then(() => {
                            let organQuery = Storage.Last.session().get('organQuery');
                            let redirectPath = organQuery?.originVendor ? `${PATH.DESK2_RESET_PASSWORD_VENDOR.replace(':vendor', encodeURIComponent(organQuery.originVendor))}` : PATH.DESK2_RESET_PASSWORD;
                            Storage.clear();
                            this.getHelpers().getRouter().pushRedirect(redirectPath);
                        });
                        return;
                    } else {
                        Alert.error(e.body.errors[0].description);
                    }
                }
            }
        }
    }
    //图片验证码（只出现在登录）
    protected sendSmsCodePic = async () => {
        // validate mobile
        await this.onBlur(this.fieldCheck, 'mobile');
        if (this.state.errorMsg?.mobile && this.state.errorMsg.mobile.length) {
            return;
        }
        if (this.state.canSend) {
            let operationType = ''; // 验证码类型:100 注册,101登录,102 重置密码
            if (window.location.href.includes(PATH.DESK2_SIGN_IN)) {
                operationType = '101';
            } else if (window.location.href.includes(PATH.DESK2_SIGN_UP)) {
                operationType = '100';
            } else {
                operationType = '102';
            }
            try {
                let params: {[propName: string]: any} = {
                    tenantCode: this.tenantCode,
                    operationType:  operationType,
                    mobile: this.state.mobile
                };
                if (this.state.validCaptchaCode && this.state.captchaCode) {
                    params.imageVerificationCode = this.state.captchaCode;
                }
                let res = await this.getHelpers().getAjax().post(Apis.MEJ_VALIDATE,  Object.assign({},params,{
                    decryptedBody: Utils.generateSmsDecryptedBody(params.mobile)
                }), { loading: true });
                if (this.state.validCaptchaCode) {
                    if (this.state.captchaCode) {
                        params.imageVerificationCode = this.state.captchaCode; // TODO: 入参在调用后组装？
                    } else {
                        this.triggerCaptchaPic((captchaCode: string) => {
                            // this.setState({ captchaCode: captchaCode });
                            this.sendSmsCodePic();
                        },{
                            src: res?.body?.body?.message,
                            num: res?.body?.body?.result
                        });
                        return;
                    }
                }      
                // this.setState({ captchaCode: res?.body?.body?.code });
                this.startInterval(smsCount, () => {
                    this.setState({ validCaptchaCode: false });
                });
                if (res?.body?.body?.code) { // 发送验证码超过5次不触发倒计时
                    this.stopInterval();
                    this.setState({
                        count: smsCount,
                        canSend: true
                    });
                    if (res?.body?.body?.code === 'needImageVerification') {
                        this.triggerCaptchaPic((captchaCode: string) => {
                            this.setState({
                                captchaCode: captchaCode,
                                validCaptchaCode: true
                            });
                            this.sendSmsCodePic();
                        }, {
                            src: res?.body?.body?.message,
                            num: res?.body?.body?.result
                        });
                        return;
                    }
                    //     if(res?.body?.body?.code!=='账户已锁定'){
                    //         this.triggerCaptchaPic((captchaCode: string) => {
                    //         // this.setState({ captchaCode: res?.body?.body?.code });
                    //         this.sendSmsCode();
                    //     },{
                    //         src: res?.body?.body?.message,
                    //         num: res?.body?.body?.result
                    //     });
                    //     return;
                    // }
                }
            } catch (e) {
                console.log('send validate code error', e);
                Alert.hide();
                if (e?.body?.errors && e.body.errors.length) {
                    Alert.error(e.body.errors[0].description);
                }
            }
        }
    }

    protected handleChange(event: React.FormEvent<HTMLInputElement>) {
        const target = event.target as HTMLInputElement;
        let value = target.type === 'checkbox' ? target.checked : target.value;
        this.setState({[target.name]: value}, () => {
            if (this.state.errorMsg[target.name]) {
                this.onBlur(this.fieldCheck, target.name, {
                    hideMsg: true
                });
            }
        });
    }
    hasReadFile = () => {
        this.setState({hasRead: true}); // 已阅读
        // this.setState({checked: true});
    }

    protected  closeQRDialog(){
       //do nothing
    }

    readFile = (showButton: boolean, callback?: any, fileType?: string | string[],isNew?:boolean) => {
        const Iframe = (props: {path: string, getWindowHeight?: any}) => {
            const [iframeHeight, setIframeHeight] = useState<string>('0px');
            const iframeRef = useRef(document.createElement('iframe'));
            let iframePath = props.path;
            if(isNew === true){
                iframePath = iframePath + `?isNew=Y&t=${(new Date()).getMonth()}${(new Date()).getDate()}${(new Date()).getHours()}`;
            }else{
                iframePath = iframePath + `?t=${(new Date()).getMonth()}${(new Date()).getDate()}${(new Date()).getHours()}`;
            }
            return <iframe title={fileType || 'file'} onLoad={() => {
                                // @ts-ignore TODO...
                                let height = iframeRef.current.contentWindow.document.body.scrollHeight + 80;
                                setIframeHeight(height + 'px');
                                props.getWindowHeight && props.getWindowHeight(height);
                            }} ref={iframeRef} height={iframeHeight} src={iframePath}
                            style={{width: '100%', height: iframeHeight, overflow: 'visible'}} frameBorder="0" scrolling="no"  width="100%"
                    />;
        }
        const C = this.getComponents();
        // let title = !fileType ? `请先阅读《用户协议》及《个人信息收集声明》` : `《${fileType === 'agreement' ? '用户协议' : '个人信息收集声明'}》`;
        let innerFileList = fileList.filter(item => !fileType || Utils.toArray(fileType).includes(item.type));
        const FileReader = () => {
            const [currentFileIndex, setCurrentFileIndex] = useState<number>(0);
            const [canConfirm, setCanConfirm] = useState<boolean>(false);
            const [iframeHeight, setIframeHeight] = useState<number>(0);
            const iframeWrapperRef = useRef(document.createElement('div'));
            useEffect(() => {
                if (iframeWrapperRef.current) {
                    iframeWrapperRef.current.onscroll = () => {
                        // console.log('iframe height', iframeHeight)
                        // console.log('iframe wrapper height', iframeWrapperRef.current.scrollTop)
                        if (iframeWrapperRef.current.scrollTop + iframeWrapperRef.current.offsetHeight >= iframeHeight) {
                            setCanConfirm(true);
                        }
                    }
                }
            }, [iframeWrapperRef.current]);
            return <>
            <a style={{ position: 'absolute', top: '10px', right: '20px', cursor: 'pointer', fontSize: '36px', zIndex: 2 }} onClick={() => {
                Dialog.hide(dialog);
                this.closeQRDialog();
            }}>&times;</a>
            {innerFileList.map((item, fileIndex) => {
                    return currentFileIndex === fileIndex ? <div ref={iframeWrapperRef} key={fileIndex} style={{
                        overflowY: 'scroll',
                        height: 'calc(100% - 72px)',
                        minHeight: 'calc(300px - 72px)',
                        position: 'relative',
                        padding: '0 60px'
                    }}>
                        <Iframe path={item.path} getWindowHeight={(height: number) => {
                            setIframeHeight(height);
                        }} />
                    </div> : null
                })}
                {showButton ? <C.Row align="center" css={() => `
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    background: #fff;
                    margin-bottom: 40px;
                `}>
                    <DeskButton type={ButtonType.PRIMARY} css={() => `padding-left: 130px;padding-right: 130px;`}
                                onClick={() => {
                                    if (!canConfirm) {
                                        Alert.hint('请拖动页面，完整阅读协议至底部', () => `[data-widget="alert-box"] {
                                            top: 50vh!important;
                                            width: 250px!important;
                                            padding: 10px;
                                            background: rgba(0, 0, 0, .7);
                                            [data-widget="fas"] {
                                                display: none;
                                            }
                                            [data-widget="alert-body"] {
                                                background: transparent;
                                                margin: 0;
                                                color: #fff;
                                            }
                                            [data-widget="alert-msg-line"] {
                                                margin: 0;
                                                text-align: center
                                            }
                                        }`);
                                    } else {
                                        setCurrentFileIndex(currentFileIndex + 1);
                                        setCanConfirm(false);
                                        if (currentFileIndex === innerFileList.length - 1) {
                                            callback && callback();
                                            Dialog.hide(dialog);
                                        }
                                    }
                                }}>我已阅读并同意</DeskButton>
                </C.Row> : null}
            </>
        }
        const dialog = Dialog.show('',
        <DeskPanel>
            <DeskPanelBody css={() => `padding: 10px 0;min-height:300px;`}>
                <FileReader />
            </DeskPanelBody>
        </DeskPanel>,
        null,
        {boxCSS: {width: '800px', padding: '0 0 20px 0'}});
    }
    protected renderFormBody = (C: SignCommonPageComponents2) => {
        return <>
            <C.Row>
                <label>手机号码</label>
                <C.Input type="text" autoComplete="mobile" placeholder="请输入手机号码" maxLength={11} name="mobile" value={this.state.mobile} onChange={evt => this.handleChange(evt)} onBlur={() => {
                    this.onBlur(this.fieldCheck, 'mobile');
                }} />
                {this.state.errorMsg.mobile ? <C.Error>{this.state.errorMsg.mobile}</C.Error> : null}
            </C.Row>
            <C.Row>
                <label>验证码</label>
                <C.Input type="text" autoComplete="off" placeholder="请输入验证码" maxLength={6} name="validateCode" value={this.state.validateCode} onChange={evt => this.handleChange(evt)} onBlur={() => {
                    this.onBlur(this.fieldCheck, 'validateCode');
                }} />
                <C.Link className="sms-btn" disabled={!this.state.mobile || !this.state.canSend} onClick={() => this.sendSmsCode()}
                        css={() => `top: 32px!important;`}>
                    {this.state.canSend ? '发送验证码' : '已发送（' + this.state.count + 's）'}
                </C.Link>
                {this.state.errorMsg.validateCode ? <C.Error>{this.state.errorMsg.validateCode}</C.Error> : null}
            </C.Row>
            <C.Row>
                <label>密码</label>
                <C.Input type="password" autoComplete="new-password" placeholder="请输入密码" maxLength={this.state.pwdStrategy?.maxLength || 99} name="password" value={this.state.password} onChange={evt => this.handleChange(evt)} onBlur={() => {
                    this.onBlur(this.fieldCheck, 'password');
                }} />
                <Line>
                    {/* <img alt="" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAMCAMAAABlXnzoAAAAS1BMVEUAAAD7ZE74ZE35Y036Y03/X1D5Y038ZE77ZU35Y076ZE35Y074Y035Y034Y076Zk75ZU/4Ykv2Ykr/Yk78ZVD6Y03/Zk//aFD9ZU8MJ3EBAAAAFXRSTlMA7D66pQh5+fHmzbGbi3JkUUQpGlb/AdK4AAAAYElEQVQI103HVw7DMBAD0c2quPeQ1P1PGshJbM/HAM/OUozJ7mZpvnV0UndcnBSCpr/2Vu5q9x+juG1U/Mob0J1o/GQgyjgWMFStBSjDUL+apZ4Ac67vky3EFbO9X4+WD7BtBg2BkwDDAAAAAElFTkSuQmCC" /> */}
                    {this.state.pwdStrategy?.desc}
                </Line>
                {this.state.errorMsg.password ? <C.Error>{this.state.errorMsg.password}</C.Error> : null}
            </C.Row>
            <C.Row key="confirmPassword">
                <label>确认密码</label>
                <C.Input type="password" autoComplete="off" placeholder="请再次输入密码" maxLength={this.state.pwdStrategy?.maxLength || 99} name="confirmPassword" value={this.state.confirmPassword} onChange={evt => this.handleChange(evt)} onBlur={() => {
                    this.onBlur(this.fieldCheck, 'confirmPassword');
                }} />
                {this.state.errorMsg.confirmPassword ? <C.Error>{this.state.errorMsg.confirmPassword}</C.Error> : null}
            </C.Row>
        </>
    }
    protected initComponents() {
        const FormBox = Styled.form.attrs({'data-widget': 'sign-up-wrapper'})`
            width: 420px;
            margin: 60px auto;
            h1 {
                font-family: 'PingFangSC-Medium', 'PingFang SC Medium', 'PingFang SC', sans-serif;
                margin-bottom: 20px;
                font-weight: 500;
                font-size: 26px;
            }
            label {
                width: 100%;
                line-height: 1;
                margin-bottom: 8px;
                &:not([for]):after {
                    display: inline-block;
                    content: ' *';
                    padding-left: 5px;
                    color: ${props => props.theme.COLOR_DANGER};
                    // font-family: 'Font Awesome 5 Free';
                    // font-weight: 900;
                    // transform: scale(0.6);
                }
            }
        `
        const Input = Styled(StyledComponents.INPUT)`
            border: 1px solid ${props => props.theme.BORDER_COLOR_MINOR_LIGHT};
            line-height: 44px;
            height: 44px;
            background: #fff;
            flex: 1;
            &::-ms-reveal,
            &::-ms-clear {
                display: none;
            }
        `
        const Row = Styled.div<{align?: string}>`
            display: flex;
            flex-wrap: wrap;
            margin-bottom: 15px;
            justify-content: ${props => props.align || 'start'};
            position: relative;
            hr {
                flex: 1;
                opacity: .3;
            }
            [type="checkbox"] {
                margin-top: 3px;
            }
            [type="checkbox"] + label {
                padding-left: 20px;
                width: auto;
                line-height: 1.5;
            }
            ${(props: StyledProps) => (props.css ? props.css(props, (props as any).theme) : '')}
        `
        const Link = Styled(StyledComponents.LINK)<{disabled?: boolean}>`
            color: ${props => props.color || props.theme.COLOR_PRIMARY};
            text-decoration: none;
            line-height: 1.5;
            height: auto;
            padding: 0;
            &.sms-btn {
                position: absolute;
                z-index: 2;
                right: 0;
                top: 10px;
                line-height: 24px;
                height: 24px;
                padding: 0 10px;
                border-left: 1px solid ${props => props.theme.BORDER_COLOR_MINOR_LIGHT};
                &[disabled] {
                    color: ${props => props.theme.COLOR_DISABLED};
                }
            }
        `
        const Button = Styled(StyledComponents.BUTTON)`
            flex: 1;
            position: relative;
            &[disabled]::after {
                content: '';
                display: block;
                position: absolute;
                top: 0; right: 0; bottom: 0; left: 0;
                background: rgba(256, 256, 256, .7);
            }
        `
        const Error = Styled.div`
            position: absolute;
            bottom: -15px;
            line-height: 1;
            color: ${props => props.theme.COLOR_ERROR};
            ${(props: StyledProps) => (props.css ? props.css(props, (props as any).theme) : '')}
        `
        const CheckBox = Styled(StyledComponents.CHECKBOX)`
            position: absolute;
            left: 0;
            height: auto;
        `
        return Object.assign(super.initComponents(), {
            FormBox,
            Row,
            Link,
            Input,
            Button,
            Error,
            CheckBox
        })
    }
}

export default SignCommonPage;